import React from 'react';

/**
 * Diagonal SOLD ribbon overlay for vehicle cards.
 * Positions absolutely within a `relative` parent (e.g. card image wrapper).
 *
 * Usage:
 *   <div className="relative">
 *     <img className={truck.is_sold ? 'grayscale opacity-80' : ''} ... />
 *     {truck.is_sold && <SoldRibbon />}
 *   </div>
 */
export const SoldRibbon = ({ size = 'md' }) => {
  const sizes = {
    sm: { wrap: 'w-24 h-24', band: 'w-40 text-xs py-1', offset: 'top-4 -right-10' },
    md: { wrap: 'w-32 h-32', band: 'w-48 text-sm py-1.5', offset: 'top-5 -right-12' },
    lg: { wrap: 'w-40 h-40', band: 'w-60 text-base py-2', offset: 'top-6 -right-14' },
  };
  const s = sizes[size] || sizes.md;

  return (
    <div
      className={`pointer-events-none absolute top-0 right-0 ${s.wrap} overflow-hidden z-10`}
      data-testid="sold-ribbon"
      aria-label="Sold"
    >
      <div
        className={`absolute ${s.offset} ${s.band} bg-black text-orange-500 font-black uppercase text-center shadow-xl rotate-45 border-y-2 border-orange-500`}
        style={{ fontFamily: '"Helvetica Neue", Arial, sans-serif', letterSpacing: '0.2em' }}
      >
        Sold
      </div>
    </div>
  );
};

/**
 * Wide SOLD banner used on TruckDetailPage hero/summary.
 */
export const SoldBanner = () => (
  <div
    className="bg-black text-orange-500 px-6 py-3 rounded-lg inline-flex items-center gap-3 shadow-lg border-2 border-orange-500"
    data-testid="sold-banner"
  >
    <span className="text-2xl font-black tracking-widest uppercase">Sold</span>
    <span className="text-sm font-medium text-orange-300">This vehicle is no longer available for sale</span>
  </div>
);

export default SoldRibbon;
